/**
 *
 * ItaIllustrationPage
 *
 */

import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { get } from 'lodash/object';
import { FormattedMessage } from 'react-intl';
import {
  useHistory,
  useLocation,
  Switch,
  Route,
  Redirect,
} from 'react-router-dom';
import { createStructuredSelector } from 'reselect';
import { compose } from 'redux';

import { useInjectSaga } from 'utils/injectSaga';
import { useInjectReducer } from 'utils/injectReducer';
import globalMessages from 'containers/App/messages';
import { Grid, Typography, Button } from '@material-ui/core';
import FormHeader from 'components/FormHeader';
import FormFooter from 'components/FormFooter';
import { makeSelectSubPage } from 'containers/DashboardPage/selectors';
import {
  changeSubPageAction,
  changeSubPageListAction,
} from 'containers/DashboardPage/actions';
import { submit } from 'redux-form';
import {
  makeSelectOption,
  makeSelectAgentDetails,
  makeSelectOfferCodeData,
  makeSelectErrorOfferCodeData,
} from 'containers/App/selectors';
import FormMainBody from 'components/FormMainBody';
import { isEmpty, find, isEqual } from 'lodash';
import { usePrevious } from 'utils/hooks';
import LoadingDialog from 'components/LoadingDialog';
import Dialog from 'components/Dialog';
import NoticeBox from 'components/NoticeBox';
import { MIN_DATE_QUOTE_VALID } from 'helpers/date';
import { makeSelectProductConfig as makeSelectProductConfig2 } from 'containers/IllustrationPage/selectors';
import CoverageForm from './components/CoverageForm';
import BenefitRatingForm from './components/BenefitRatingForm';
import QuoteForm from './components/QuoteForm';
import Review from './components/Review';
import {
  makeSelectLifeAssured,
  makeSelectProductConfig,
  makeSelectError,
  makeSelectConfig,
  makeSelectStatus,
  makeSelectApplicationId,
  makeSelectQuoteId,
  makeSelectFiaCharge,
  makeSelectInitialLifeAssured,
  makeSelectCloneStatus,
  makeSelectCompletedDialog,
  makeSelectIsCalculateQuotePage,
} from './selectors';
import {
  ChangeLifeAssuredAction,
  ChangeCoverageAction,
  createQuoteAction,
  setErrorAction,
  SetCoveragesListAction,
  updateStatusAction,
  resetAction,
  createApplicationAction,
  setItaConfigAction,
  getQuoteAction,
  setQuoteAction,
  getFiaAction,
  cloneQuoteAction,
  setCloneStatusAction,
  setPtvVersionAction,
  setCompletedDialogAction,
  setProductCodeAction,
} from './actions';
import LifeAssuredForm from './components/LifeAssuredForm';
import { getCoverages } from './helper';
import messages from './messages';
import saga from './saga';
import reducer from './reducer';

const subPageListITA = [
  { order: 1, text: 'Life Insured', subOrder: [] },
  { order: 2, text: 'Coverage', subOrder: [] },
  { order: 3, text: 'Quote', subOrder: [] },
  { order: 4, text: 'Review', subOrder: [] },
];

export function ItaIllustrationPage({
  quoteId,
  saveQuote,
  setCoverage,
  itaConfig,
  setItaConfig,
  subPage,
  isCalculateQuotePage,
  changeSubPage,
  changeSubPageList,
  lifeAssured,
  initialLifeAssured,
  changeLifeAssured,
  productConfig,
  changeCoverage,
  submitLifeAssured,
  submitCoverage,
  submitBenefitRating,
  submitQuote,
  options,
  updateStatus,
  errorData,
  applicationId,
  status,
  createApplication,
  setError,
  resetData,
  agentDetails,
  getQuote,
  setQuoteId,
  fiaData,
  callFia,
  cloneQuote,
  cloneStatus,
  changeCloneStatus,
  setPtvVersion,
  offerCodeData,
  completedDialog,
  setCompletedDialog,
  offerCodeErrorMsg,
  setProductCode,
  productConfig2,
}) {
  useInjectReducer({ key: 'itaIllustrationPage', reducer });
  useInjectSaga({ key: 'itaIllustrationPage', saga });
  const history = useHistory();
  const location = useLocation();

  const [product, setProduct] = useState({});
  const [isLifeAssuredEqual, setLifeAssuredEqual] = useState(false);
  const minValidDate = new Date(MIN_DATE_QUOTE_VALID);
  const createDate = new Date(productConfig.createdAt);
  const isValidQuoteByDate =
    productConfig.requiredKFS && createDate.getTime() > minValidDate.getTime();
  useEffect(() => {
    if (applicationId) {
      history.replace(`/applications/${applicationId}`);
    }
  }, [applicationId]);

  useEffect(() => {
    if (cloneStatus) {
      history.replace({
        pathname: '/illustrations/ita',
        state: { itaConfig, quoteId, type: 2 },
      });
      getQuote(2);
      changeCloneStatus(false);
    }
  }, [cloneStatus]);

  useEffect(() => {
    if (
      productConfig.premium != '0' &&
      status != 'SAVED' &&
      status != 'PREVIEW' &&
      status != 'AGREED'
    ) {
      return history.replace('/illustrations/ita/quote', location.state);
    }

    if (
      location.pathname === '/illustrations/ita/quote' &&
      productConfig.premium == '0' &&
      !isCalculateQuotePage
    ) {
      return history.replace('/illustrations/ita/coverage', location.state);
    }
  }, [productConfig.premium]);

  useEffect(() => {
    if (status === 'AGREED') {
      createApplication();
    }
    if ((status === 'SAVED' || status === 'PREVIEW') && !isEmpty(quoteId)) {
      history.replace('/illustrations/ita/review', location.state);
    }
  }, [status]);

  const prevItaConfig = usePrevious(itaConfig);

  useEffect(() => {
    if (isEmpty(prevItaConfig) && !isEmpty(itaConfig))
      setCoverage(getCoverages(itaConfig.features));
  }, [itaConfig]);

  // set the productConfig aka itaConfig
  useEffect(() => {
    setItaConfig(location.state.itaConfig);
    if (location.state.itaConfig.features.haveFiaCharge) callFia();
    if (location.state.quoteId) {
      setQuoteId(location.state.quoteId);
      getQuote(location.state.type);
    }
    // set the sub pages list for sidebar
    changeSubPageList(subPageListITA);
    return () => {
      changeSubPage(0);
      changeSubPageList([]);
      resetData();
    };
  }, []);

  useEffect(() => {
    if (!isEmpty(location.state.customerDetail)) {
      changeLifeAssured({
        ...lifeAssured,
        insuredOne: location.state.customerDetail,
      });
    }
  }, []);

  // set the product details from agent data
  useEffect(() => {
    if (itaConfig.productCode) {
      const productDetails = find(
        agentDetails.products,
        p => p.productId === itaConfig.productCode,
      );
      setPtvVersion(productDetails.PTVVersion);
      setProductCode(productDetails.PTVCode);
      setProduct(productDetails);
    }
  }, [itaConfig.productCode]);

  useEffect(() => {
    // set active subPage
    let activeSubPage = subPage;
    switch (location.pathname) {
      case '/illustrations/ita/insured':
        activeSubPage = 1;
        break;
      case '/illustrations/ita/coverage':
        activeSubPage = 2;
        break;
      case '/illustrations/ita/benefitrating':
        activeSubPage = 2;
        break;
      case '/illustrations/ita/quote':
        activeSubPage = 3;
        break;
      case '/illustrations/ita/review':
        activeSubPage = 4;
      default:
        break;
    }
    changeSubPage(activeSubPage);
  }, [location.pathname]);

  useEffect(() => {
    if (errorData.error) window.scrollTo(0, 0);
  }, [errorData]);

  const getTitle = () => {
    switch (location.pathname) {
      case '/illustrations/ita/insured':
        return globalMessages.lifeAssuredTitle;
      case '/illustrations/ita/coverage':
        return globalMessages.coverageTitle;
      case '/illustrations/ita/benefitrating':
        return globalMessages.benefitRatingTitle;
      case '/illustrations/ita/quote':
        return globalMessages.quoteTitle;
      case '/illustrations/ita/review':
        return globalMessages.reviewTitle;
      default:
        return globalMessages.lifeAssuredTitle;
    }
  };

  const getFooterLabel3 = () => {
    switch (location.pathname) {
      case '/illustrations/ita/quote':
        return globalMessages.saveQuote;
      case '/illustrations/ita/review':
        return globalMessages.agreeAndProceed;
      default:
        return globalMessages.next;
    }
  };

  if (isEmpty(product) || isEmpty(itaConfig)) {
    return <LoadingDialog isLoading />;
  }
  return (
    <>
      <FormHeader
        title={<FormattedMessage {...getTitle()} />}
        productName={itaConfig.shortName}
      />

      {errorData.error ? (
        <Grid container style={{ paddingLeft: '40px' }}>
          <Grid item xs={7}>
            <NoticeBox variant="error" mb={4}>
              {errorData.message.map(error => (
                <Typography id={error.message} variant="body2" color="error">
                  {error.message}
                </Typography>
              ))}
            </NoticeBox>
          </Grid>
        </Grid>
      ) : null}

      <FormMainBody>
        <Grid item xs={12} md={10} lg={7} xl={6}>
          <Switch>
            <Route
              path="/illustrations/ita/insured"
              render={() => (
                <LifeAssuredForm
                  initialValues={lifeAssured}
                  disabled={!!quoteId}
                  location={location}
                  options={options}
                  onSubmit={immutableValues => {
                    const currentLifeAssured = immutableValues.toJS();
                    let isLaOneEqual = false;
                    let isLaTwoEqual = false;
                    let isInsuredTwoEqual = false;
                    let isPoEqual = false;
                    let isPoValueEqual = false;

                    if (
                      isEqual(
                        initialLifeAssured.insuredOne,
                        currentLifeAssured.insuredOne,
                      )
                    )
                      isLaOneEqual = true;

                    if (
                      isEqual(
                        initialLifeAssured.insuredTwo,
                        currentLifeAssured.insuredTwo,
                      )
                    )
                      isLaTwoEqual = true;

                    if (
                      initialLifeAssured.isInsuredTwo ===
                      currentLifeAssured.isInsuredTwo
                    )
                      isInsuredTwoEqual = true;

                    if (
                      initialLifeAssured.isPolicyOwnerIndividual ===
                      currentLifeAssured.isPolicyOwnerIndividual
                    )
                      isPoEqual = true;

                    if (
                      isEqual(
                        initialLifeAssured.policyOwnerIndividual,
                        currentLifeAssured.policyOwnerIndividual,
                      )
                    )
                      isPoValueEqual = true;

                    if (
                      !initialLifeAssured.isInsuredTwo &&
                      !currentLifeAssured.isInsuredTwo
                    )
                      isLaTwoEqual = true;

                    if (
                      !initialLifeAssured.isPolicyOwnerIndividual &&
                      !currentLifeAssured.isPolicyOwnerIndividual
                    )
                      isPoValueEqual = true;

                    if (
                      isLaOneEqual &&
                      isLaTwoEqual &&
                      isInsuredTwoEqual &&
                      isPoEqual &&
                      isPoValueEqual
                    ) {
                      setLifeAssuredEqual(true);
                    }

                    changeLifeAssured(immutableValues.toJS());
                    return history.replace(
                      '/illustrations/ita/coverage',
                      location.state,
                    );
                  }}
                />
              )}
            />

            <Route
              path="/illustrations/ita/coverage"
              render={routeProps => (
                <CoverageForm
                  initialValues={{
                    ...productConfig,
                    shortName: productConfig2.shortName,
                    FMC: get(
                      find(productConfig2.features?.FMC, f => {
                        return f.region === agentDetails.ISOCountryCode;
                      }),
                      'FMCrate',
                      '',
                    ),
                  }}
                  location={location}
                  lifeAssured={lifeAssured}
                  options={options}
                  product={product}
                  itaConfig={itaConfig}
                  fiaData={fiaData}
                  offerCodeData={offerCodeData}
                  onSubmit={immutableValues => {
                    if (immutableValues.toJS().specialTermsFlag) {
                      changeCoverage(
                        immutableValues.toJS(),
                        false,
                        false,
                        false,
                        isLifeAssuredEqual,
                      );
                      return history.replace(
                        '/illustrations/ita/benefitrating',
                        location.state,
                      );
                    }
                    changeCoverage(
                      immutableValues.toJS(),
                      true,
                      false,
                      false,
                      isLifeAssuredEqual,
                    );
                  }}
                  {...routeProps}
                />
              )}
            />

            <Route
              path="/illustrations/ita/benefitrating"
              render={() => (
                <BenefitRatingForm
                  initialValues={productConfig}
                  lifeAssured={lifeAssured}
                  onSubmit={immutableValues => {
                    changeCoverage(
                      immutableValues.toJS(),
                      true,
                      false,
                      false,
                      isLifeAssuredEqual,
                    );
                  }}
                />
              )}
            />

            <Route
              path="/illustrations/ita/quote"
              render={() => (
                <QuoteForm
                  initialValues={productConfig}
                  location={location}
                  originalPremium={productConfig.premium}
                  lifeAssured={lifeAssured}
                  options={options}
                  itaConfig={itaConfig}
                  onUpdateValues={(
                    newValues,
                    reverseCalculate,
                    isCheckOfferCode = false,
                  ) => {
                    changeCoverage(
                      newValues,
                      true,
                      reverseCalculate,
                      true,
                      isLifeAssuredEqual,
                      isCheckOfferCode,
                    );
                  }}
                  onSubmit={() => saveQuote(isLifeAssuredEqual)}
                  offerCodeData={offerCodeData}
                />
              )}
            />

            <Route
              path="/illustrations/ita/review"
              render={() => (
                <Review
                  disableProceed={
                    location.pathname === '/illustrations/ita/review' &&
                    status !== 'PREVIEW'
                  }
                  isValidQuoteByDate={isValidQuoteByDate}
                  location={location}
                  onClickBackToClientList={() =>
                    setCompletedDialog({ open: true, message: 'EXIT' })
                  }
                />
              )}
            />
            <Route
              path="/"
              render={() => (
                <Redirect
                  to={{
                    pathname:
                      isEmpty(quoteId) || location.state.type === 2
                        ? '/illustrations/ita/insured'
                        : '/illustrations/ita/review',
                    state: location.state,
                  }}
                />
              )}
            />
          </Switch>
        </Grid>
      </FormMainBody>
      <FormFooter
        onClickPrevious={() => {
          setError({ error: false, message: [] });
          switch (location.pathname) {
            case '/illustrations/ita/insured':
              history.replace('/illustrations');
              break;
            case '/illustrations/ita/coverage':
              history.replace('/illustrations/ita/insured', location.state);
              break;
            case '/illustrations/ita/benefitrating':
              history.replace('/illustrations/ita/coverage', location.state);
              break;
            case '/illustrations/ita/quote':
              productConfig.specialTermsFlag
                ? history.replace(
                    '/illustrations/ita/benefitrating',
                    location.state,
                  )
                : history.replace(
                    '/illustrations/ita/coverage',
                    location.state,
                  );
              break;
            default:
              break;
          }
          return changeSubPage(subPage - 1);
        }}
        onClickExit={() =>
          setCompletedDialog({
            open: true,
            message: 'EXIT',
          })
        }
        onClickNext={() => {
          setError({ error: false, message: [] });
          switch (location.pathname) {
            case '/illustrations/ita/insured':
              submitLifeAssured();
              break;
            case '/illustrations/ita/coverage':
              submitCoverage();
              break;
            case '/illustrations/ita/benefitrating':
              submitBenefitRating();
              break;
            case '/illustrations/ita/quote':
              submitQuote();
              break;
            case '/illustrations/ita/review':
              return updateStatus(2);
            default:
              break;
          }
        }}
        disabledPrevious={
          location.pathname === '/illustrations/ita/insured' ||
          location.pathname === '/illustrations/ita/review'
        }
        disabledNext={
          (location.pathname === '/illustrations/ita/review' &&
            status != 'PREVIEW') ||
          (location.pathname === '/illustrations/ita/review' &&
            offerCodeData.errorMessage) ||
          offerCodeData.validating ||
          (location.pathname === '/illustrations/ita/quote' &&
            !isEmpty(offerCodeErrorMsg)) ||
          (location.pathname === '/illustrations/ita/quote' && errorData.error)
        }
        label1={<FormattedMessage {...globalMessages.previous} />}
        label2={<FormattedMessage {...globalMessages.exit} />}
        label3={<FormattedMessage {...getFooterLabel3()} />}
      />

      <Dialog
        open={completedDialog.open}
        onClose={() =>
          setCompletedDialog({
            ...completedDialog,
            open: false,
          })
        }
        onExited={() =>
          setCompletedDialog({
            ...completedDialog,
            message: null,
          })
        }
        variant={completedDialog.message === 'EXIT' ? 'error' : 'success'}
        title={
          <FormattedMessage
            {...(completedDialog.message === 'EXIT'
              ? globalMessages.warning
              : messages.added)}
          />
        }
        actions={
          <Grid
            container
            alignItems="center"
            wrap="nowrap"
            justify="center"
            spacing={2}
          >
            {completedDialog.message === 'ADDED' && (
              <Grid item xs={4}>
                <Button
                  fullWidth
                  variant="outlined"
                  color="primary"
                  onClick={() => {
                    setCompletedDialog({
                      open: false,
                      message: null,
                    });
                    changeSubPage(0);
                    history.replace('/illustrations');
                  }}
                >
                  <FormattedMessage {...messages.clientList} />
                </Button>
              </Grid>
            )}

            <Grid item xs={4}>
              <Button
                fullWidth
                variant="outlined"
                color="primary"
                onClick={() => {
                  setCompletedDialog({
                    open: false,
                    message: null,
                  });
                  if (completedDialog.message === 'ADDED') {
                    cloneQuote(2);
                  } else if (completedDialog.message === 'EXIT') {
                    changeSubPage(0);
                    history.replace('/illustrations');
                  }
                }}
              >
                <FormattedMessage
                  {...(completedDialog.message === 'ADDED'
                    ? messages.createAnother
                    : globalMessages.exit)}
                />
              </Button>
            </Grid>

            <Grid item xs={4}>
              <Button
                fullWidth
                variant="contained"
                color="primary"
                onClick={() => {
                  setCompletedDialog({
                    open: false,
                    message: null,
                  });
                  if (
                    completedDialog.message === 'ADDED' &&
                    !isEmpty(quoteId)
                  ) {
                    history.replace(
                      '/illustrations/ita/review',
                      location.state,
                    );
                  }
                }}
              >
                <FormattedMessage {...messages.continue} />
              </Button>
            </Grid>
          </Grid>
        }
      >
        <Typography variant="body1" style={{ fontWeight: 700 }}>
          <FormattedMessage
            {...(completedDialog.message === 'EXIT'
              ? messages.exitQuoteNotice
              : messages.addedInfo)}
          />
        </Typography>
      </Dialog>
    </>
  );
}

ItaIllustrationPage.propTypes = {
  quoteId: PropTypes.string,
  lifeAssured: PropTypes.object,
  initialLifeAssured: PropTypes.object,
  applicationId: PropTypes.string,
  productConfig: PropTypes.object,
  setCoverage: PropTypes.func,
  itaConfig: PropTypes.object,
  getQuote: PropTypes.func,
  setQuoteId: PropTypes.func,
  saveQuote: PropTypes.func,
  subPage: PropTypes.number,
  changeSubPage: PropTypes.func,
  updateStatus: PropTypes.func,
  changeSubPageList: PropTypes.func,
  changeLifeAssured: PropTypes.func,
  changeCoverage: PropTypes.func,
  submitLifeAssured: PropTypes.func,
  submitCoverage: PropTypes.func,
  submitBenefitRating: PropTypes.func,
  submitQuote: PropTypes.func,
  options: PropTypes.object,
  errorData: PropTypes.object,
  setError: PropTypes.func,
  status: PropTypes.string,
  resetData: PropTypes.func,
  createApplication: PropTypes.func,
  agentDetails: PropTypes.object,
  callFia: PropTypes.func,
  fiaData: PropTypes.object,
  cloneQuote: PropTypes.func,
  cloneStatus: PropTypes.bool,
  changeCloneStatus: PropTypes.func,
  setPtvVersion: PropTypes.func,
  offerCodeData: PropTypes.object,
  completedDialog: PropTypes.object,
  setCompletedDialog: PropTypes.func,
  isCalculateQuotePage: PropTypes.bool,
  offerCodeErrorMsg: PropTypes.string,
  setProductCode: PropTypes.func,
  productConfig2: PropTypes.object,
};

const mapStateToProps = createStructuredSelector({
  subPage: makeSelectSubPage(),
  fiaData: makeSelectFiaCharge(),
  itaConfig: makeSelectConfig(),
  lifeAssured: makeSelectLifeAssured(),
  initialLifeAssured: makeSelectInitialLifeAssured(),
  productConfig: makeSelectProductConfig(),
  options: makeSelectOption(),
  errorData: makeSelectError(),
  status: makeSelectStatus(),
  applicationId: makeSelectApplicationId(),
  agentDetails: makeSelectAgentDetails(),
  quoteId: makeSelectQuoteId(),
  cloneStatus: makeSelectCloneStatus(),
  offerCodeData: makeSelectOfferCodeData(),
  completedDialog: makeSelectCompletedDialog(),
  isCalculateQuotePage: makeSelectIsCalculateQuotePage(),
  offerCodeErrorMsg: makeSelectErrorOfferCodeData(),
  productConfig2: makeSelectProductConfig2(),
});

function mapDispatchToProps(dispatch) {
  return {
    saveQuote: value => dispatch(createQuoteAction(value)),
    setItaConfig: value => dispatch(setItaConfigAction(value)),
    setCoverage: value => dispatch(SetCoveragesListAction(value)),
    changeSubPage: value => dispatch(changeSubPageAction(value)),
    changeSubPageList: value => dispatch(changeSubPageListAction(value)),
    changeLifeAssured: value => dispatch(ChangeLifeAssuredAction(value)),
    getQuote: value => dispatch(getQuoteAction(value)),
    setQuoteId: value => dispatch(setQuoteAction(value)),
    cloneQuote: value => dispatch(cloneQuoteAction(value)),
    changeCloneStatus: value => dispatch(setCloneStatusAction(value)),
    changeCoverage: (
      value,
      reacalculateQuote = false,
      reverseCalculate = false,
      isCalculateQuotePage = false,
      isLifeAssuredEqual,
      isCheckOfferCode = false,
    ) =>
      dispatch(
        ChangeCoverageAction(
          value,
          reacalculateQuote,
          reverseCalculate,
          isCalculateQuotePage,
          isLifeAssuredEqual,
          isCheckOfferCode,
        ),
      ),
    updateStatus: val => dispatch(updateStatusAction(val)),
    resetData: () => dispatch(resetAction()),
    callFia: () => dispatch(getFiaAction()),
    setError: value => dispatch(setErrorAction(value)),
    createApplication: value => dispatch(createApplicationAction(value)),
    submitLifeAssured: () => dispatch(submit('lifeAssuredForm')),
    submitCoverage: () => dispatch(submit('coverageForm')),
    submitBenefitRating: () => dispatch(submit('benefitRatingForm')),
    submitQuote: () => dispatch(submit('quoteForm')),
    setPtvVersion: value => dispatch(setPtvVersionAction(value)),
    setProductCode: value => dispatch(setProductCodeAction(value)),
    setCompletedDialog: value => dispatch(setCompletedDialogAction(value)),
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect)(ItaIllustrationPage);
